module.exports = __webpack_public_path__ + "media/images/logo-only-90767313.png";